import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Alert,
} from "@mui/material";
import axios from "axios";
import { API_BASE } from "../services/api";
import type { RawAxiosRequestHeaders } from "axios";
import type { FolderRow } from "../types/folder";

interface Props {
  open: boolean;
  folder: FolderRow;
  onClose: () => void;
  onUpdated: () => void;
}

const FolderEditDialog: React.FC<Props> = ({
  open,
  folder,
  onClose,
  onUpdated,
}) => {
  const [name, setName] = useState(folder.name);
  const [desc, setDesc] = useState(folder.description || "");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setName(folder.name);
      setDesc(folder.description || "");
      setError(null);
    }
  }, [open, folder]);

  const getHeaders = (): RawAxiosRequestHeaders => ({
    "x-user-id": localStorage.getItem("user_id") || "",
    "x-access-token": localStorage.getItem("access_token") || "",
    "x-refresh-token": localStorage.getItem("refresh_token") || "",
  });

  const handleSave = async () => {
    setError(null);
    if (!name.trim()) {
      setError("폴더명을 입력하세요.");
      return;
    }
    setBusy(true);
    try {
      const res = await axios.put(
        `${API_BASE}folders/${folder.folder_id}`,
        {
          name: name.trim(),
          description: desc.trim() || null,
        },
        { headers: getHeaders() }
      );
      if (!res.data?.success) {
        setError(res.data?.error || res.data?.message || "수정 실패");
        return;
      }
      onUpdated();
    } catch (e: any) {
      setError(e?.message || "요청 실패");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>폴더 정보 수정</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="폴더명"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="설명"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            multiline
            minRows={3}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          취소
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={busy}>
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderEditDialog;
